// Fase 42.1: generación de contraseña para altas de usuario (UsersView/ClientsView) -- se hace
// en el frontend (no en el backend) para poder mostrarla en pantalla a quien crea la cuenta
// antes de mandarla. Charset sin caracteres ambiguos (0/O/1/l/I), cosmético, no crítico.
export function generateSecurePassword(length = 16) {
    const charset = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz23456789';
    const values = crypto.getRandomValues(new Uint32Array(length));
    return Array.from(values, (v) => charset[v % charset.length]).join('');
}
